var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29253 9.45747L10.2879 13.4528C10.476 13.6409 10.7311 13.7466 10.9971 13.7466C11.2631 13.7466 11.5182 13.6409 11.7062 13.4528C11.8943 13.2648 12 13.0097 12 12.7437C12 12.4777 11.8943 12.2226 11.7062 12.0345L8.41007 8.7483L11.7062 5.46211C11.8943 5.27402 12 5.01892 12 4.75293C12 4.62122 11.9741 4.49081 11.9237 4.36912C11.8733 4.24744 11.7994 4.13688 11.7062 4.04375C11.6131 3.95062 11.5026 3.87675 11.3809 3.82634C11.2592 3.77594 11.1288 3.75 10.9971 3.75C10.7311 3.75 10.476 3.85567 10.2879 4.04375L6.29253 8.03912C6.19891 8.13197 6.1246 8.24245 6.07389 8.36417C6.02318 8.48588 5.99707 8.61644 5.99707 8.7483C5.99707 8.88016 6.02318 9.01071 6.07389 9.13243C6.1246 9.25415 6.19891 9.36462 6.29253 9.45747Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.e35c7396b81f102a03ce971f71137384.svg";
export { ForwardRef as ReactComponent };